/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { Stack, StackProps } from '@mui/material';
import styles from './SummaryTableComponent.module.scss';

const SummaryTableComponent: FC<StackProps> = (props) => (
  <Stack
      className={styles.SummaryTableComponent}
      data-testid="SummaryTableComponent"
      spacing="16px"
      {...props}
  />
);

export default SummaryTableComponent;
